'use client';

import { useEffect, useRef, useState } from 'react';
import { Typography } from '@bgzt/ui';
import clsx from 'clsx';

import { Spacing } from '~/components';

import styles from './ShopReviewContent.module.css';

type Props = {
  content: string;
};

export const ShopReviewContent = ({ content }: Props) => {
  const ref = useRef<HTMLDivElement>(null);
  const [showAll, setShowAll] = useState(false);
  const [isMoreContents, setIsMoreContents] = useState(false);

  useEffect(() => {
    if (!ref.current || typeof window === 'undefined') return;
    const lineHeight = parseFloat(globalThis?.window?.getComputedStyle(ref.current).lineHeight);
    const maxLines = 3;
    const maxHeight = lineHeight * maxLines;
    if (ref.current.scrollHeight > maxHeight) {
      setIsMoreContents(true);
    }
  }, [ref]);
  if (!content) return;
  return (
    <div className={clsx(styles.container)}>
      <Typography
        as="div"
        ref={ref}
        variant="B5"
        color="gray-800"
        className={clsx([styles.content, showAll ? styles.noLineClamp : styles.lineClamp])}
      >
        {content}
      </Typography>
      {isMoreContents && !showAll && (
        <>
          <Spacing height={2} />
          <Typography variant="B5" color="gray-400" onClick={() => setShowAll(true)} className={styles.more}>
            더보기
          </Typography>
        </>
      )}
    </div>
  );
};
